export default class MessageDetailsPageController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.state = this.injector.get('$state');
        this.stateParams = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.translate = this.injector.get('$translate');
        this.usersStore = this.injector.get('Users');
        this.navService = this.injector.get('NavService');
        this.workflows = this.injector.get('Workflows');
        this.alert = this.injector.get('Alert');
        this.fileSaver = this.injector.get('FileSaver');

        this.message = null;
        this.loading = true;
        this.selectedIndex = -1;
        this.currentView = 'desktop';

        this.stateTimeline = [];
    }

    $onInit() {
        this._loadMessage();
        this.store = this.stateParams.store;
    }

    goToView(newView) {
        this.currentView = newView;
    }

    goToMessage(message) {
        this.state.go(
            'app.messages.details',
            {
                id: message.id,
                message,
                store: this.store
            },
            {
                reload: true
            }
        );
    }

    downloadAttachment(name) {
        this.api
            .get(`messages/${this.message.id}/attachment/${name}`, {
                responseType: 'blob',
                ignoreLoadingBar: true
            })
            .then(({data, headers}) => this.fileSaver.saveAs(
                new Blob([data], {type: headers('content-type')}),
                name
            ))
            .catch(e => this.alert.handle(e))
    }

    _loadMessage() {
        this.api.get(`messages/${this.stateParams.id}?include=template,contact`)
            .then(({data}) => {
                this.message = data.data;
                this._prepareTimeLine();
                this._decorateNavService();
                this.loading = false;

                if (this.store) {
                    this.selectedIndex = _.findIndex(this.store.state.data, {id: this.message.id});
                }
            })
            .catch(e => this.alert.handle(e));
    }

    _prepareTimeLine() {
        let timelineStates = [
            {
                key: 'scheduled',
                icon: 'clock',
                useCounts: false
            },
            {
                key: 'processed',
                icon: 'paper-plane',
                useCounts: false
            },
            {
                key: 'delivered',
                icon: 'envelope',
                useCounts: false
            },
            {
                key: 'opened',
                icon: 'envelope-open',
                useCounts: true
            },
            {
                key: 'clicked',
                icon: 'mouse',
                useCounts: true
            }
        ];

        if(this.message.type === 'sms') {
            timelineStates = [
                {
                    key: 'scheduled',
                    icon: 'clock',
                    useCounts: false
                },
                {
                    key: 'delivered',
                    icon: 'envelope',
                    useCounts: false
                }
            ];
        }
        this.stateTimeline = [];

        _.each(timelineStates, (state) => {
            const filteredStates = _.filter(this.message.states, (mState) => (mState.state === state.key)),
                newTimelineEntry = {
                    icon: state.icon,
                    label: this.translate.instant(`messages.states.${state.key}`),
                    completed: filteredStates.length > 0,
                    failed: false,
                    count: state.useCounts ? filteredStates.length : 0
                };

            switch (state.key) {
                case 'processed':
                    if (['error', 'invalid_send_to', 'blacklisted', 'dropped'].indexOf(this.message.status) !== -1) {
                        newTimelineEntry.completed = false;
                        newTimelineEntry.failed = true;
                        // newTimelineEntry.icon = 'times';
                    }
                    break;
                case 'delivered':
                    if (['bounced', 'blocked', 'deferred'].indexOf(this.message.status) !== -1) {
                        newTimelineEntry.completed = false;
                        newTimelineEntry.failed = true;
                        // newTimelineEntry.icon = 'times';
                    }
                    break;
                case 'clicked':
                    if (!_.get(this.usersStore, 'state.company.settings.messages.enable_click_tracking', false)) {
                        newTimelineEntry.completed = false;
                        newTimelineEntry.count = 0;
                        newTimelineEntry.label = `${this.translate.instant('messages.views.click_tracking')}<br><small>${this.translate.instant('messages.views.not_activated')}</small>`;
                    }
                    break;
                case 'opened':
                    if (!_.get(this.usersStore, 'state.company.settings.messages.enable_open_tracking', false)) {
                        newTimelineEntry.count = 0;
                        newTimelineEntry.completed = false;
                        newTimelineEntry.label = `${this.translate.instant('messages.views.open_tracking')}<br><small>${this.translate.instant('messages.views.not_activated')}</small>`;
                    }
                    break;
            }

            this.stateTimeline.push(newTimelineEntry);
        })
    }

    _decorateNavService() {
        const highlights = _(this.workflows.getWorkflows('messages::details'))
            .filter(workflow => {
                return this.message.archived
                    ? workflow.level === 'archived-highlight'
                    : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.message, this);
                };
                workflow.order = workflow.order || 30;
                return workflow;
            })
            .sortBy('order', 'asc')
            .value();

        this.navService.overrideMainSideNavActions(highlights);
    }
}

MessageDetailsPageController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/details.js